import React, { createContext, useContext, useState, useEffect } from 'react';

const SectionsContext = createContext();

export const SectionsProvider = ({ children }) => {
    const [sections, setSections] = useState({});
    const [selectedSections, setSelectedSections] = useState({});

    // Load sections from localStorage on initialization
    useEffect(() => {
        const savedSections = localStorage.getItem("sections");
        if (savedSections) {
            try {
                const parsedSections = JSON.parse(savedSections);
                setSections(parsedSections);
            } catch (error) {
                console.error('Error parsing saved sections:', error);
            }
        }
    }, []);

    // Load selectedSections from localStorage on initialization
    useEffect(() => {
        const savedSelectedSections = localStorage.getItem("selectedSections") || sessionStorage.getItem("selectedSections");
        if (savedSelectedSections) {
            try {
                const parsedSelectedSections = JSON.parse(savedSelectedSections);
                setSelectedSections(parsedSelectedSections);
                return; // Don't generate defaults if we have saved data
            } catch (error) {
                console.error('Error parsing saved selectedSections:', error);
            }
        }
        
        // Only generate defaults if no saved selectedSections exist and we have sections
        if (sections && Object.keys(sections).length > 0) {
            const defaults = {};
        
            for (const [file, fileSections] of Object.entries(sections)) {
                const defaultSection = fileSections.sections[0];
                defaults[file] = defaultSection;
            }
        
            setSelectedSections(defaults);
            localStorage.setItem("selectedSections", JSON.stringify(defaults));
            sessionStorage.setItem("selectedSections", JSON.stringify(defaults)); // Backup for OAuth redirects
        }
    }, [sections]);

    const updateSections = (newSections) => {
        setSections(newSections);
        localStorage.setItem("sections", JSON.stringify(newSections));
        sessionStorage.setItem("sections", JSON.stringify(newSections)); // Backup for OAuth redirects
    };

    const handleSectionChange = (file, sectionJson) => {
        const section = JSON.parse(sectionJson);
        const updatedSections = { ...selectedSections, [file]: section };
        setSelectedSections(updatedSections);
        localStorage.setItem("selectedSections", JSON.stringify(updatedSections));
        sessionStorage.setItem("selectedSections", JSON.stringify(updatedSections)); // Backup for OAuth redirects
    };

    return (
        <SectionsContext.Provider 
            value={{ 
                sections,
                selectedSections,
                updateSections,
                handleSectionChange
            }}
        >
            {children}
        </SectionsContext.Provider>
    );
};

export const useSections = () => {
    const context = useContext(SectionsContext);
    if (!context) {
        throw new Error('useSections must be used within a SectionsProvider');
    }
    return context;
};
